import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import Script from "react-inline-script";
import AnalyticsProvider from "./AnalyticsProvider";
import EmbeddedHead from "./EmbeddedHead";
function IframePage(param) {
    var head = param.head, useFullstory = param.useFullstory, analyticsProvider = param.analyticsProvider, children = param.children;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(EmbeddedHead, {
                title: head.title,
                useFullstory: useFullstory,
                children: [
                    /*#__PURE__*/ _jsx(Script, {
                        children: "\n              window['_fs_is_outer_script'] = true;\n           "
                    }),
                    /*#__PURE__*/ _jsx("base", {
                        target: "_parent"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(AnalyticsProvider, _object_spread_props(_object_spread({}, analyticsProvider), {
                children: children
            }))
        ]
    });
}
export default IframePage;
